<template>
  <div class='account'>
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">物业查询</h3>
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
      </div>
    </div>
    <div class="main" v-if="list.length">
      <div class="box" @click='detalis(month,0)'>
        <p><van-icon name="bookmark-o" /><span>全部</span></p><van-icon name="arrow" />
      </div>
      <div v-for="(item, index) in list" :key="index">
        <div class="box" @click='detalis(month,item)'>
          <p><van-icon name="bookmark-o" /><span>单元编号：{{item}}</span></p><van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div>
      <van-tabbar v-model="active">
        <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
        <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
        <van-tabbar-item :to="`${this.currentParkId == 1003||this.currentParkId == 1000||this.currentParkId == 1006?'/parkCompleteSet/foodCourt':'/humanResource/jobList'}`"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
        <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
        <van-tabbar-item to="/personal"><div class="divicon"><van-icon size='22px' name="contact" />我的</div></van-tabbar-item>
      </van-tabbar>
    </div>
    
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';

export default {
  data(){
    return {
      active:4,
      unitCode:"",
      qiniuConfig: {},
      list:[],
      year: new Date().getFullYear(),
      month:'',
      total_proceeds:'',
      total_profits:'',
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    };
  },
  methods: {
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
    getbianm(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {},{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          if(res.resData.unitCode){
            this.list = res.resData.unitCode.split(",");
          } 
        }
      });
    },
    detalis(month,id) {
      this.$router.push({ path: `/BianDetalis/${month}/${id}` });
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {
        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId']),
  },
  created() {
    this.month = location.href.split('PayDetalis/')[1];
    this.getUploadToken();
    this.getbianm();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.account{
  .onehome{
    background: #205eff;
    width: 100%;
    height: 1.2rem;
    display: flex;
    justify-content:space-between;
    align-items: center;
    .return{
      padding-left: .18rem;
    }
    .title{
      text-align: center;
      color: #fff;
      padding-left: .88rem;
    }
    .imgbox{
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: .18rem;
    }
  }
  .main{
    // background: #d3d6d8;
    margin-bottom: 1.2rem;
    .box{
      height: 1.2rem;
      background: #fff;
      border-bottom: 6px solid #d3d6d8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .5rem;
      p{
        display: flex;
        align-items: center;
        .van-icon{
          margin-right: .08rem;
        }
      }
    }
  }
  .divicon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      padding-bottom: .1rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/detalis/PayDetalis.vue